/**
 * Transition.js
 * Transition component powered by ReactCSSTransitionGroup
 *
 * @class   Transition
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react/addons';
import ClassNames from 'classnames';
import TimeoutTransitionGroup from 'components/transition-groups/TimeoutTransitionGroup'

const ReactCSSTransitionGroup = React.addons.CSSTransitionGroup;

export default React.createClass({



	propTypes: {
		type: React.PropTypes.oneOf(['slide-in', 'drop-down', 'scale', 'fader']).isRequired,
		direction: React.PropTypes.oneOf(['left', 'right', 'up', 'down'])
	},

	getDefaultProps() {
		return {
			direction: 'up',
			className: '',
			type: 'slide-in'
		};
	},


	render() {

		let { className, type, direction } = this.props;

		let classes;

		if (type === 'slide-in'){
			classes = ClassNames( this.props.className , `lui-transition-${type}` , `lui-is-${direction}`);
		} else {
			classes = ClassNames( this.props.className , `lui-transition-${type}`);
		};

		// // Add a custom className to every child
		// React.Children.forEach(function(child) {
		// 	child.props.className = child.props.className ?
		// 		`${child.props.className} lui-transition-${type}-child` :
		// 		``;
		// }); 

		return (
			<TimeoutTransitionGroup
				className={classes}
				transitionName={`lui-transition-${this.props.type}`}
				component="div"
				enterTimeout={150}
				leaveTimeout={150}>

				{this._getChildren()}
			</TimeoutTransitionGroup>
		);
 	},

	_getChildren() {

		return React.Children.map(this.props.children, function(child) {
			if (child){
				return React.addons.cloneWithProps(child, {
					className: child.props.className ? 
						ClassNames(child.props.className, `lui-transition-${this.props.type}-child`) : `lui-transition-${this.props.type}-child`,
				});
			};

		}.bind(this))

	}

});



/** WEBPACK FOOTER **
 ** ./src/components/transition-groups/Transition.js
 **/